export default "__VITE_ASSET__59b6bdf2__"